const WeightChart = ({ currentWeight, goalWeight, unit = "kg" }) => {
  // Format weight with unit
  const formatWeight = (weight) => {
    if (!weight) return unit === "kg" ? "0kg" : "0lb";
    return `${Math.round(weight)}${unit}`;
  };

  const startWeight = formatWeight(currentWeight);
  const endWeight = formatWeight(goalWeight);

  return (
    <svg
      width="490"
      height="297"
      viewBox="0 0 490 297"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-auto"
    >
      <g clipPath="url(#clip0_chart)">
        <g clipPath="url(#clip1_chart)">
          {/* Green gradient fill area */}
          <path
            d="M0.177734 60.8755C0.177734 60.8755 87.7852 42.7399 257.162 159.959C372.763 239.963 489.634 228.962 489.634 228.962V289.65H0.177734V60.8755Z"
            fill="url(#paint0_linear_chart)"
          />

          {/* Vertical grid lines */}
          <path
            d="M37.0374 35.7324H36.1309V267.304H37.0374V35.7324Z"
            fill="#D2D2D2"
          />
          <path
            d="M246.496 124.303H245.636V267.303H246.496V124.303Z"
            fill="#D2D2D2"
          />
          <path
            d="M455.983 203.322H455.076V267.303H455.983V203.322Z"
            fill="#D2D2D2"
          />

          {/* Red line (With dieting) */}
          <path
            d="M485.39 119.585C485.118 119.857 484.81 120.111 484.502 120.347C484.43 120.42 484.339 120.474 484.266 120.529C483.922 120.819 484.484 120.366 484.303 120.493C484.085 120.656 483.886 120.801 483.668 120.965C483.142 121.346 482.616 121.709 482.073 122.054C478.519 124.323 475.02 125.866 471.103 127.119C456.2 131.911 439.937 130.659 424.961 126.883C416.294 124.704 407.845 121.727 399.088 119.894C389.116 117.824 378.891 116.916 368.719 117.207C358.693 117.497 348.667 118.931 338.949 121.491C330.319 123.778 321.96 126.955 313.747 130.423C298.1 137.049 282.798 144.91 266.154 148.794C248.948 152.806 231.108 151.481 214.047 147.397C197.384 143.403 181.448 136.777 166.308 128.789C152.874 121.691 140.019 113.503 127.636 104.717C117.174 97.3102 107.239 89.1228 96.3965 82.2607C89.0173 77.577 81.3481 73.3471 73.4068 69.7164C65.9189 66.2853 58.1408 63.2718 50.0726 61.5108C46.6822 60.7665 43.2011 60.2582 39.72 60.113C37.3811 60.0222 37.3993 63.653 39.72 63.7438C47.2261 64.0342 54.6053 66.1582 61.6219 68.7361C69.7988 71.7315 77.6675 75.5801 85.2643 79.8462C92.8611 84.1124 99.5513 88.4148 106.223 93.389C110.629 96.6748 114.999 100.015 119.423 103.265C131.135 111.833 143.192 119.948 155.793 127.155C170.624 135.651 186.234 142.967 202.588 148.014C219.304 153.188 237.345 156.256 254.841 154.386C272.155 152.534 288.11 145.69 303.866 138.683C311.844 135.143 319.839 131.585 328.07 128.662C337.063 125.467 346.346 123.07 355.81 121.836C365.891 120.529 376.135 120.42 386.234 121.509C395.625 122.526 404.618 124.868 413.647 127.518C422.713 130.169 431.832 132.51 441.26 133.4C448.984 134.126 456.816 133.945 464.468 132.51C472.119 131.076 480.713 128.063 487.095 122.834C487.385 122.598 487.675 122.362 487.929 122.108C489.597 120.474 487.04 117.897 485.372 119.549L485.39 119.585Z"
            fill="#FF6D50"
          />

          {/* Green line (With Naori) */}
          <path
            d="M475.419 231.231C440.481 231.231 347.398 224.623 256.128 161.447C89.5614 46.1707 1.40995 62.4728 0.539681 62.6544L-0.185547 59.0962C0.720988 58.9147 22.6047 54.5941 65.5745 64.6876C137.046 81.4799 209.768 124.94 258.195 158.452C371.874 237.131 488.31 227.255 489.47 227.146L489.814 230.759C489.579 230.777 484.43 231.231 475.419 231.231Z"
            fill="#128058"
          />

          {/* Data point circles with shadows */}
          <g filter="url(#filter0_chart)">
            <path
              d="M36.1492 68.8084C39.9142 68.8084 42.9663 65.7524 42.9663 61.9826C42.9663 58.2128 39.9142 55.1567 36.1492 55.1567C32.3842 55.1567 29.332 58.2128 29.332 61.9826C29.332 65.7524 32.3842 68.8084 36.1492 68.8084Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter1_chart)">
            <path
              d="M246.066 159.959C249.831 159.959 252.883 156.903 252.883 153.133C252.883 149.363 249.831 146.307 246.066 146.307C242.301 146.307 239.249 149.363 239.249 153.133C239.249 156.903 242.301 159.959 246.066 159.959Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter2_chart)">
            <path
              d="M455.53 236.296C459.295 236.296 462.347 233.24 462.347 229.47C462.347 225.7 459.295 222.644 455.53 222.644C451.765 222.644 448.713 225.7 448.713 229.47C448.713 233.24 451.765 236.296 455.53 236.296Z"
              fill="white"
            />
          </g>

          {/* Top left box outline (start weight) */}
          <path
            d="M55.7843 35.7142H17.4016C9.40595 35.7142 2.87891 29.197 2.87891 21.173C2.87891 13.149 9.40595 6.6499 17.4016 6.6499H55.7843C63.7799 6.6499 70.3069 13.1671 70.3069 21.1911C70.3069 29.2151 63.798 35.7323 55.7843 35.7323V35.7142ZM17.4016 7.55759C9.89548 7.55759 3.78544 13.6754 3.78544 21.1911C3.78544 28.7068 9.89548 34.8246 17.4016 34.8246H55.7843C63.2904 34.8246 69.4004 28.7068 69.4004 21.1911C69.4004 13.6754 63.2904 7.55759 55.7843 7.55759H17.4016Z"
            fill="#D2D2D2"
          />

          {/* Top right box outline (end weight) */}
          <path
            d="M475.292 203.304H436.909C428.914 203.304 422.387 196.787 422.387 188.763C422.387 180.739 428.914 174.24 436.909 174.24H475.292C483.288 174.24 489.815 180.757 489.815 188.781C489.815 196.805 483.306 203.322 475.292 203.322V203.304ZM436.909 175.147C429.403 175.147 423.293 181.265 423.293 188.781C423.293 196.297 429.403 202.414 436.909 202.414H475.292C482.798 202.414 488.908 196.297 488.908 188.781C488.908 181.265 482.798 175.147 475.292 175.147H436.909Z"
            fill="#D2D2D2"
          />

          {/* Middle Weight Point text */}
          <text
            x="246"
            y="100"
            textAnchor="middle"
            fill="#374A42"
            fillOpacity="0.7"
            fontSize="12"
            fontFamily="system-ui, sans-serif"
          >
            <tspan>Middle Weight Point</tspan>
          </text>

          {/* Bottom labels: Today, 30 days, 60+ days */}
          <text
            x="36"
            y="280"
            textAnchor="middle"
            fill="#374A42"
            fillOpacity="0.7"
            fontSize="12"
            fontFamily="system-ui, sans-serif"
          >
            Today
          </text>
          <text
            x="246"
            y="280"
            textAnchor="middle"
            fill="#374A42"
            fillOpacity="0.7"
            fontSize="12"
            fontFamily="system-ui, sans-serif"
          >
            30 days
          </text>
          <text
            x="456"
            y="280"
            textAnchor="middle"
            fill="#374A42"
            fillOpacity="0.7"
            fontSize="12"
            fontFamily="system-ui, sans-serif"
          >
            60+ days
          </text>

          {/* Start weight (top left box) - DYNAMIC */}
          <text
            x="36"
            y="25"
            textAnchor="middle"
            fill="#374A42"
            fillOpacity="0.7"
            fontSize="13"
            fontWeight="500"
            fontFamily="system-ui, sans-serif"
          >
            {startWeight}
          </text>

          {/* End weight (top right box) - DYNAMIC */}
          <text
            x="456"
            y="193"
            textAnchor="middle"
            fill="#374A42"
            fillOpacity="0.7"
            fontSize="13"
            fontWeight="500"
            fontFamily="system-ui, sans-serif"
          >
            {endWeight}
          </text>
        </g>
      </g>

      {/* Definitions */}
      <defs>
        <filter
          id="filter0_chart"
          x="26.132"
          y="51.9567"
          width="20.0348"
          height="20.0519"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0"
          />
          <feBlend
            mode="multiply"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_chart"
          x="236.049"
          y="143.107"
          width="20.0348"
          height="20.0519"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0"
          />
          <feBlend
            mode="multiply"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_chart"
          x="445.513"
          y="219.444"
          width="20.0348"
          height="20.0519"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0"
          />
          <feBlend
            mode="multiply"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_chart"
          x1="244.906"
          y1="59.8628"
          x2="244.906"
          y2="302.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D2EEE5" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_chart">
          <rect width="489.63" height="296.3" fill="white" />
        </clipPath>
        <clipPath id="clip1_chart">
          <rect
            width="490"
            height="283"
            fill="white"
            transform="translate(-0.185547 6.6499)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default WeightChart;
